//export const Paneladdress = 'https://saadminangular420250529212625-fjfthuesg3c3gehd.centralindia-01.azurewebsites.net/';
//export const Paneladdress = 'http://192.168.2.50:64360/';
export const Paneladdress = "https://ips.bharatlogicllp.com/api/";
//  export const Paneladdress = 'https://ipspanel.azurewebsites.net/';
//export const Paneladdress = 'http://localhost:64360/';
// export const PaypalBaseurl = "https://api.paypal.com/"; //For Paypal Environment
export const PaypalBaseurl = "https://api.sandbox.paypal.com/"; // For Sandbox Environment
// export const Paneladdress =  'http://192.168.1.118:8085/';

//////////////PayPal Credential///////////

//Orignal Links
/*PaypalBaseurl = "https://api.paypal.com/";
 ClientId = "AcmWl9vQB_7fpSV7nY3pq-F8Zzl76aLcRyo8lSfN6mytuxzgpQY2BPe4wbPBU5YxbaGcMbv6f3wlWWW4";
 ClientSecret = "EGVhg2bTyxL25sEi7mTZAZASSUxu-1ogeMjZev7Zzwzv3naPGs5v7_u92QFq5DcAgbf0vHwVKfp3XQvw";

*/

/*Sandbox Link
PaypalBaseurl = "https://api.sandbox.paypal.com/";
 ClientId = "ATKzAlrruDisLpdAX5y_YkXWK7J6VSUiH96G8sJJFwJX-UJJLtOCCQ0ThNnO9WvGKlAF2ftt-XuCTe0x";
 ClientSecret = "EOIxZdcS5AjhtCn7xKKbpyxz24wXCjnFzSskWACX9ECV27YiT9812cM_Y2vc_90DemKd2fqMgljmHKMd";*/

//Steps to Change Paypal Environment
//1. Change Client ID in index.html
